import { useEffect, useState, useRef, useMemo } from 'react';
import { Paper, Typography } from '@mui/material';
import { Row } from '../NewCustomers';
import ModalToInvoice from 'app/main/Invoices/Invoices/Modals/ModalToInvoice';
import Button from '@mui/material/Button';
import store from 'app/store';
import client from 'client';
import { changeCurrency } from '../../../../constants';
import { showMessage } from 'app/store/fuse/messageSlice';
import { useDispatch } from 'react-redux';
import withReducer from 'app/store/withReducer';
import JobReducer from 'app/stores/loadz/redux/Jobs';
import { connect } from 'react-redux';
import JobAction from 'app/stores/loadz/redux/Jobs/actions';
import {useTranslation} from 'react-i18next';
import moment from 'moment';

function ClientsData({
  handleDrawerToggle,
  infoCustomer,
  rechargedAfterChanges,
  handleApplyPaymentInvoice,
  setShowInvoiceInApply,
  accumulateInvoiceApply,
  setAccumulateInvoiceApply,
  infoPayments,
  tickets,
  setTickets,
  setInfo,
  info,
  openModalViewInvoice,
  setInfoCustomer,
  customerId,
  tabValue,
  setInfoPayments,
  searchByJobNo,
  searchByInvoiceNo,
  prop_data,
  paymentsearch,
  date1,
  date2,
  hasGlobalSearched,
  hasGlobalTicketSearched,
  globalResults,
  setTabValue,
  setInvoiceDate1,
  setInvoiceDate2,
  invoiceDate1,
  invoiceDate2,
  getPerCustomerDate,
  handleDateSearch,
  page,
  setPage,
  hasNextPage,
  setHasNextPage,
  listLoading,
  setListLoading,
  globalSearch,
  globalTicketSearch,
  sorting,
  setSorting,
  SortColumn,
  setDisableList,
  grandTotalHauling,
  grandTotalWait,
  grandTotal,
  grandTotalBalance,
  setGrandTotalHauling,
  setGrandTotalWait,
  setGrandTotal,
  setGrandTotalBalance,
  grandTotalMaterial,
  setGrandTotalMaterial,
  setGrandTotalAgent,
  grandTotalAgent,
  setBolData,
  bolData,
  refreshCustomers,
  setSelectedCustomer,
  selectedCustomer,
  rows,
  getBolPendingCount,
  openModalCustomer,
  create,
  setCreate,
  resetFilters,
  setShouldClearFilters,
  filterInvoiceNo,
  filterJobNo,
  filterProjectName,
  filterInvoiceDate1,
  filterInvoiceDate2,
  filterPaymentsearch,
  filterDate1,
  filterDate2,
}) {
  const {t} = useTranslation('navigation');
  const openModalEditInvoice = useRef(null);
  const dispatch = useDispatch()
  
  // Ref para evitar que el cambio de tab desde customerId dispare el useEffect de tabValue
  const isLoadingFromCustomerId = useRef(false);
  const previousCustomerId = useRef(null);
  
  // Refs para prevenir llamadas API simultáneas
  const isLoadingPerCustomer = useRef(false);
  const isLoadingPayments = useRef(false);
  const isLoadingBolJobs = useRef(false);
  const previousInvoiceJobFilter = useRef({ invoice: '', job: '' });

  const getInvoiceBalanceAmount = (inv) => {
    if (inv?.balance == null || inv?.balance === '') return 0;
    try {
      return changeCurrency(inv.balance);
    } catch {
      return 0;
    }
  };

  // Invoices for the ticket search result — do not mutate globalResults
  const getGlobalTicketInvoices = (forCustomerId, { unpaid } = { unpaid: true }) => {
    const invoices = [];
    (globalResults || []).forEach((res) => {
      if (res.customer_id != forCustomerId) return;
      (res.invoices || []).forEach((inv) => {
        const bal = getInvoiceBalanceAmount(inv);
        if (unpaid ? bal > 0 : bal <= 0) {
          invoices.push(inv);
        }
      });
    });
    return invoices;
  };

  //this fires on customer select
  useEffect(() => {
    // Reset so the same customer can be re-selected after a global ticket search clears customerId
    if (!customerId) {
      previousCustomerId.current = null;
      return;
    }

    // Solo ejecutar si el customerId realmente cambió
    if (customerId !== previousCustomerId.current) {
      previousCustomerId.current = customerId;
      previousInvoiceJobFilter.current = { invoice: '', job: '' };
      isLoadingFromCustomerId.current = true;
      
      const loadCustomerData = async () => {
        setSelectedBOL([])
        setPage(1);
        setSorting({
          invoice: { active: false, order: 'asc' },
          job: { active: false, order: 'asc' },
          dateUpdated: { active: false, order: 'asc' },
          dueDate: { active: false, order: 'asc' },
          projectName: { active: false, order: 'asc' },
          totalHauling: { active: false, order: 'asc' },
          totalWait: { active: false, order: 'asc' },
          material: { active: false, order: 'asc' },
          grandTotal: { active: false, order: 'asc' },
          balancePending: { active: false, order: 'asc' },
          agent: { active: false, order: 'asc' },
          current: { column: '', order: '' },
          flag: false,
        });
        setInfoCustomer([]);
        setInfoPayments([]);
        setInvoiceDate1('');
        setInvoiceDate2('');
        setHasNextPage(true);

        try {
          if (hasGlobalTicketSearched == false) {
            await getPerCustomer();
          } else {
            const unpaidInvoices = getGlobalTicketInvoices(customerId, { unpaid: true });
            const paidInvoices = getGlobalTicketInvoices(customerId, { unpaid: false });

            if (unpaidInvoices.length > 0) {
              setInfoCustomer(unpaidInvoices);
              if (tabValue !== 0) setTabValue(0);
            } else {
              setInfoCustomer(paidInvoices);
              if (tabValue !== 1) setTabValue(1);
            }
          }
        } finally {
          // Defer so a tabValue change from above still sees this flag and skips the tab effect
          setTimeout(() => {
            isLoadingFromCustomerId.current = false;
          }, 0);
        }
      };
      
      loadCustomerData();
    }
  }, [customerId]);

  //this fires when they change tabs
  useEffect(() => {
    // No ejecutar si el cambio de tabValue proviene del useEffect de customerId
    if (customerId && !isLoadingFromCustomerId.current) {
      const loadTabData = async () => {
        setPage(1);
        setSelectedBOL([])
        setInfoCustomer([]);
        setInfoPayments([]);
        setBolData([]);
        setInvoiceDate1('');
        setInvoiceDate2('');
        setHasNextPage(true);

        if (tabValue == 0 || tabValue == 1) {
          if (hasGlobalTicketSearched == false) {
            await getPerCustomer();
          } else {
            if (tabValue == 0) {
              setInfoCustomer(getGlobalTicketInvoices(customerId, { unpaid: true }));
            }
            if (tabValue == 1) {
              setInfoCustomer(getGlobalTicketInvoices(customerId, { unpaid: false }));
            }
          }
        }

        if (tabValue == 2) {
          await getPaymentPerCustomer();
        }

        if(tabValue == 3 || tabValue == 4)
        {
          await getBolJobs();
        }

        setSorting({
          invoice: { active: false, order: 'asc' },
          job: { active: false, order: 'asc' },
          dateUpdated: { active: false, order: 'asc' },
          dueDate: { active: false, order: 'asc' },
          projectName: { active: false, order: 'asc' },
          totalHauling: { active: false, order: 'asc' },
          totalWait: { active: false, order: 'asc' },
          material: { active: false, order: 'asc' },
          grandTotal: { active: false, order: 'asc' },
          balancePending: { active: false, order: 'asc' },
          agent: { active: false, order: 'asc' },
          current: { column: '', order: '' },
          flag: false,
        });
      };
      
      loadTabData();
    }
  }, [tabValue]);

  const listInnerRef = useRef();
  const [scrollX, setScrollX] = useState(0);
  const [tableLoading, setTableLoading] = useState(false);

  const state = store.getState();

  // DISABLED: Date filtering is now handled locally in CustomersApp.js
  /* useEffect(async () => {
    //if dates are cleared load all invoices based on tab
    if (!invoiceDate1 && !invoiceDate2 && !globalTicketSearch && !globalSearch) {
      setPage(1);
      setHasNextPage(true);
      if (tabValue == 0 || tabValue == 1) {
        getPerCustomer();
      }

      if (tabValue == 2) {
        getPaymentPerCustomer();
      }
    }
  }, [invoiceDate1, invoiceDate2]); */

  // When Invoice No or Job No filter changes, refetch so backend returns that invoice (e.g. 8827)
  useEffect(() => {
    if (!customerId || (tabValue !== 0 && tabValue !== 1)) return;
    // Keep ticket-search results; do not overwrite with a full invoice list fetch
    if (hasGlobalTicketSearched) return;
    const inv = (searchByInvoiceNo || '').trim();
    const job = (searchByJobNo || '').trim();
    if (inv === previousInvoiceJobFilter.current.invoice && job === previousInvoiceJobFilter.current.job) return;
    previousInvoiceJobFilter.current = { invoice: inv, job };
    const timer = setTimeout(() => {
      setPage(1);
      setHasNextPage(true);
      getPerCustomer(1);
    }, 400);
    return () => clearTimeout(timer);
  }, [searchByInvoiceNo, searchByJobNo]);

  const getPaymentPerCustomer = async (page = 1) => {
    // Prevenir llamadas simultáneas
    if (isLoadingPayments.current) {
      console.log('getPaymentPerCustomer: Ya hay una llamada en progreso, ignorando...');
      return;
    }
    
    const user = prop_data ? prop_data : state?.loadz_auth?.AuthReducer?.user;
    if (customerId && user) {
      isLoadingPayments.current = true;
      setDisableList(true);
      setTableLoading(true);
      
      try {
        // Modified: Remove filter parameters - filtering is now done locally
        const result = await client.get(
          `/payments/get-payments/customer/${customerId}/${
            prop_data ? prop_data?.compacctnum : user?.company?.compacctnum
          }/0/null/null/null/null`,
          {
            params: {
              page,
            },
          }
        );
        let new_data = infoPayments;
        page == 1
          ? (new_data = result.data)
          : result?.data?.payment && !Array.isArray(result?.data?.payment)
          ? new_data?.payment?.invoice_no_search.push(...result?.data?.payment?.invoice_no_search) &&
            new_data?.payment?.ref_conf_search.push(...result?.data?.payment?.ref_conf_search)
          : result?.data?.payment
          ? new_data?.payment.push(...result?.data?.payment)
          : new_data;
        const data = new_data;
        if (
          result.data?.payment?.length > 0 ||
          result.data?.payment?.invoice_no_search.length > 0 ||
          result.data?.payment?.ref_conf_search.length > 0
        ) {
          setPage(page);
          setInfoPayments(data);
          
          // Trigger filter clearing through state flag
          if (page > 1 && typeof setShouldClearFilters === 'function') {
            setShouldClearFilters(true);
          }
        }
        if (
          !result?.data?.payment ||
          result.data?.payment?.length == 0 ||
          (!Array.isArray(result?.data?.payment) &&
            result.data?.payment?.invoice_no_search?.length == 0 &&
            result.data?.payment?.ref_conf_search?.length == 0)
        ) {
          setHasNextPage(false);
          page == 1 ? setInfoPayments([]) : null;
        }
        console.log('customer invoice::getPayment customer', data);
        setInfoCustomer([]);
      } catch (error) {
        console.error('Error in getPaymentPerCustomer:', error);
      } finally {
        setTableLoading(false);
        setDisableList(false);
        isLoadingPayments.current = false;
      }
    }
  };

  const getPerCustomer = async (page = 1) => {
    // Prevenir llamadas simultáneas
    if (isLoadingPerCustomer.current) {
      console.log('getPerCustomer: Ya hay una llamada en progreso, ignorando...');
      return;
    }
    
    const user = prop_data ? prop_data : state?.loadz_auth?.AuthReducer?.user;
    const status = tabValue == 1 ? 0 : 1;
    if (customerId && user) {
      isLoadingPerCustomer.current = true;
      setDisableList(true);
      setTableLoading(true);
      
      try {
        // Pass Invoice No / Job No so backend returns that invoice (avoids pagination hiding it)
        const invoicenosearch = searchByInvoiceNo?.trim() || 'null';
        const jobnosearch = searchByJobNo?.trim() || 'null';
        const result = await client.get(
          `/invoices/customer/${
            prop_data ? prop_data.compacctnum : user?.company?.compacctnum
          }/${customerId}/${status}/${invoicenosearch}/${jobnosearch}`,
          {
            params: {
              page,
            },
          }
        );

        let new_data = [...infoCustomer];
        const only_invoices = [];
        if (page == 1) {
          result.data.map(async (job) => {
            job.invoices.map(async (invoice) => {
              only_invoices.push(invoice);
            });
          });
          if (result.data.length) {
            setGrandTotal(result.data[0].totals.grandTotal);
            setGrandTotalBalance(result.data[0].totals.grandTotalBalance);
            setGrandTotalHauling(result.data[0].totals.grandTotalHauling);
            setGrandTotalWait(result.data[0].totals.grandTotalWait);
            setGrandTotalMaterial(result.data[0].totals.grandTotalMaterial);
            setGrandTotalAgent(result.data[0].totals.grandTotalAgentCommission);
          }
          if (sorting.flag) {
            SortColumn(sorting.current.order, sorting.current.column, only_invoices);
          } else {
            setInfoCustomer(only_invoices);
          }
        } else {
          result.data.map(async (job) => {
            job.invoices.map(async (invoice) => {
              only_invoices.push(invoice);
            });
          });
          new_data.push(...only_invoices);
          if (sorting.flag) {
            SortColumn(sorting.current.order, sorting.current.column, new_data);
          } else {
            setInfoCustomer(new_data);
          }
          
          // Trigger filter clearing through state flag
          if (typeof setShouldClearFilters === 'function') {
            setShouldClearFilters(true);
          }
        }

        if (
          result.data?.length > 0 ||
          result.data?.invoice_no_search?.length > 0 ||
          result.data?.job_no_search?.length > 0
        ) {
          setPage(page);
        }
        if (
          result.data?.length == 0 ||
          (result.data?.invoice_no_search?.length == 0 && result.data?.job_no_search?.length == 0)
        ) {
          setHasNextPage(false);
        }
        setInfoPayments([]);
      } catch (error) {
        console.error('Error in getPerCustomer:', error);
      } finally {
        setTableLoading(false);
        setDisableList(false);
        isLoadingPerCustomer.current = false;
      }
    }
  };

  const _showMessage = (msg, color) => {
      dispatch(
        showMessage({
          message: <Typography>{msg}</Typography>,
          autoHideDuration: 6000,
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'right',
          },
          variant: color,
        })
      );
  };

  const getBolJobs = async(page=1, jobNoFilter = '') => {
    // Prevenir llamadas simultáneas
    if (isLoadingBolJobs.current) {
      console.log('getBolJobs: Ya hay una llamada en progreso, ignorando...');
      return;
    }

    isLoadingBolJobs.current = true;
    setDisableList(true);
    setTableLoading(true);
    
    try {
      const user = prop_data ? prop_data : state?.loadz_auth?.AuthReducer?.user.company;
      // Modified: Remove job_no filter - filtering is now done locally
      const result = await client.post(`/jobs/get-bol-jobs?page=${page}`,{
        compacctnum:user.compacctnum,
        reconciled:tabValue == 3 ? false : tabValue == 4 ? true : false,
        customer_id:customerId,
        all:false,
        job_no: null
      })

        console.log('bol jobs',result.data)

        if(result.data.message)
        {
          setHasNextPage(false)
        }

        if(result.data.message && page == 1)
        {
          _showMessage(result.data.message,'info')
          setBolData([])
          setHasNextPage(false)
        }
        else
        {
           if(page == 1)
          {
            setBolData(result.data.data)
          }
          else
          {
            //need to search result.data.data if the job already exists in bolData
            const new_data = [...bolData]
            const new_jobs = result.data.data

            for(let i = 0; i < new_jobs.length; i++)
            {
              const index = new_data.findIndex(x => x.job_id == new_jobs[i].job_id)
              if(index == -1)
              {
                new_data[index].tickets.push(...new_jobs[i].tickets)
              }
            }
            setBolData(new_data)
            
            // Trigger filter clearing through state flag
            if (typeof setShouldClearFilters === 'function') {
              setShouldClearFilters(true);
            }
          }
        }
        setPage(page);
    } catch (error) {
      console.error('Error in getBolJobs:', error);
    } finally {
      setDisableList(false);
      setTableLoading(false);
      isLoadingBolJobs.current = false;
    }
  }

  const [selectedBOL, setSelectedBOL] = useState([]);

  const updateBOLTicketInvoice = (async() => {
    const user = prop_data ? prop_data : state?.loadz_auth?.AuthReducer?.user.company;

    //console.log('ROWS => ', rows)
    //console.log('selectedCustomer => ', selectedCustomer)

    try {
      
    
      //setSelectedCustomer
      //selectedCustomer
      //rows
      /**after bol job refresh after submitting invoice no refresh customers then find the customer in the new rows and set selected customer refreshCustomers*/
      //START HERE
      
      //need to ask for specific customer 

      //update 
      const result = await client.post(`/jobs/update-bol-tickets`,{tickets:selectedBOL})



      if(result.data.message)
      {
        _showMessage(result.data.message,'success')
      }
      else
      {
        _showMessage('Error updating BOL','error')
      }

      //get BOL
      await getBolJobs()

      //get customers
      refreshCustomers(selectedCustomer.customers_id).then((customers) => {
        console.log('Customers updated: ', rows);
      })

      //get global bol counter
      await getBolPendingCount({ compacctnum: user.compacctnum }, (error) => {
        console.log('Error getting BOL pending count at CustomerData updateBOLTicketInvoice function: ', error);
      });

      //get selected customer in useEffect

    } catch (error) {
      console.log('Error updating BOL tickets: ',error)

      _showMessage('Error updating BOL','error')
    }


  })

  useEffect(() => {
    if(tabValue == 3 || tabValue == 4)
    {
      console.log('ROWS => ', rows)
      const found = rows.find(x => x.customer.customers_id == selectedCustomer.customers_id);
    
      if (found) {
        console.log('found customer',found.customer)
        setSelectedCustomer(found.customer);
      }
    }

  },[rows,tabValue])

  // Apply client-side filtering for infoCustomer based on filters
  const filteredInfoCustomer = useMemo(() => {
    if (!Array.isArray(infoCustomer)) return infoCustomer;
    
    let filtered = [...infoCustomer];
    
    // Filter by Invoice No
    if (filterInvoiceNo) {
      filtered = filtered.filter((item) => 
        item.invoice?.toString() === filterInvoiceNo
      );
    }
    
    // Filter by Job No
    if (filterJobNo) {
      filtered = filtered.filter((item) => 
        item.job?.toString() === filterJobNo
      );
    }
    
    // Filter by Project Name
    if (filterProjectName) {
      filtered = filtered.filter((item) => 
        item.project_name === filterProjectName
      );
    }
    
    // Filter by Date Range
    if (filterInvoiceDate1 && filterInvoiceDate2) {
      const startDate = moment(filterInvoiceDate1).startOf('day');
      const endDate = moment(filterInvoiceDate2).endOf('day');
      
      filtered = filtered.filter((item) => {
        const itemDate = moment(
          item.date_updated || 
          item.dateUpdated || 
          item.date_created || 
          item.dateCreated || 
          item.dueDate || 
          item.due_date
        );
        return itemDate.isBetween(startDate, endDate, null, '[]');
      });
    }
    
    return filtered;
  }, [infoCustomer, filterInvoiceNo, filterJobNo, filterProjectName, filterInvoiceDate1, filterInvoiceDate2]);

  // Apply client-side filtering for bolData
  const filteredBolData = useMemo(() => {
    if (!Array.isArray(bolData)) return bolData;
    
    let filtered = [...bolData];
    
    // Filter by Job No in BOL data
    if (filterJobNo && filtered.length > 0) {
      filtered = filtered.map(bol => {
        if (bol.jobs && Array.isArray(bol.jobs)) {
          return {
            ...bol,
            jobs: bol.jobs.filter(job => job.job_no?.toString() === filterJobNo)
          };
        }
        return bol;
      }).filter(bol => bol.jobs && bol.jobs.length > 0);
    }
    
    // Filter by Date Range in BOL data
    if (filterInvoiceDate1 && filterInvoiceDate2) {
      const startDate = moment(filterInvoiceDate1).startOf('day');
      const endDate = moment(filterInvoiceDate2).endOf('day');
      
      filtered = filtered.map(bol => {
        if (bol.jobs && Array.isArray(bol.jobs)) {
          return {
            ...bol,
            jobs: bol.jobs.filter(job => {
              const itemDate = moment(job.date_created || job.dateCreated);
              return itemDate.isBetween(startDate, endDate, null, '[]');
            })
          };
        }
        return bol;
      }).filter(bol => bol.jobs && bol.jobs.length > 0);
    }
    
    return filtered;
  }, [bolData, filterJobNo, filterInvoiceDate1, filterInvoiceDate2]);

  // Apply client-side filtering for infoPayments
  const filteredInfoPayments = useMemo(() => {
    if (!infoPayments?.payment) return infoPayments;
    
    let filteredPayments = { ...infoPayments };
    
    if (Array.isArray(infoPayments.payment)) {
      let filtered = [...infoPayments.payment];
      
      // Filter by payment search
      if (filterPaymentsearch) {
        filtered = filtered.filter(payment => {
          if (payment.payments && Array.isArray(payment.payments)) {
            return payment.payments.some(p => 
              (p.invoice_no && p.invoice_no.toString().toLowerCase().includes(filterPaymentsearch.toLowerCase())) ||
              (p.payment_no && p.payment_no.toString().toLowerCase().includes(filterPaymentsearch.toLowerCase()))
            );
          }
          return false;
        });
      }
      
      // Filter by invoice number
      if (filterInvoiceNo) {
        filtered = filtered.filter(payment => {
          if (payment.payments && Array.isArray(payment.payments)) {
            return payment.payments.some(p => 
              p.invoice_no && p.invoice_no.toString() === filterInvoiceNo
            );
          }
          return false;
        });
      }
      
      // Filter by date range
      if (filterDate1 && filterDate2) {
        const startDate = moment(filterDate1).startOf('day');
        const endDate = moment(filterDate2).endOf('day');
        
        filtered = filtered.filter(payment => {
          if (payment.payments && Array.isArray(payment.payments)) {
            return payment.payments.some(p => {
              const paymentDate = moment(p.payment_date || p.date);
              return paymentDate.isBetween(startDate, endDate, null, '[]');
            });
          }
          return false;
        });
      }
      
      filteredPayments = { ...infoPayments, payment: filtered };
    }
    
    return filteredPayments;
  }, [infoPayments, filterInvoiceNo, filterDate1, filterDate2, filterPaymentsearch]);



  if (
    bolData?.length > 0 ||
    infoCustomer.length > 0 ||
    !Array.isArray(infoCustomer) ||
    infoPayments?.payment?.length > 0 ||
    (infoPayments?.payment && !Array.isArray(infoPayments?.payment))
  ) {
    return (
      <>
        <ModalToInvoice
          getPerCustomer={getPerCustomer}
          prop_data={prop_data}
          tickets={tickets}
          openModal={openModalEditInvoice}
          info={info}
          rechargedAfterChanges={rechargedAfterChanges}
        />

        <Row
        updateBOLTicketInvoice={updateBOLTicketInvoice}
        selectedBOL={selectedBOL}
        setSelectedBOL={setSelectedBOL}
        getBolJobs={getBolJobs}
        bolData={filteredBolData}
        setBolData={setBolData}
          grandTotalHauling={grandTotalHauling}
          grandTotalWait={grandTotalWait}
          grandTotal={grandTotal}
          grandTotalBalance={grandTotalBalance}
          grandTotalMaterial={grandTotalMaterial}
          grandTotalAgent={grandTotalAgent}
          sorting={sorting}
          setSorting={setSorting}
          SortColumn={SortColumn}
          invoiceDate1={invoiceDate1}
          invoiceDate2={invoiceDate2}
          setInvoiceDate1={setInvoiceDate1}
          setInvoiceDate2={setInvoiceDate2}
          handleDateSearch={handleDateSearch}
          getPerCustomerDate={getPerCustomerDate}
          hasGlobalSearched={hasGlobalSearched}
          hasGlobalTicketSearched={hasGlobalTicketSearched}
          tabValue={tabValue}
          listLoading={listLoading}
          hasNextPage={hasNextPage}
          page={page}
          getPerCustomer={getPerCustomer}
          getPaymentPerCustomer={getPaymentPerCustomer}
          prop_data={prop_data}
          row={filteredInfoCustomer}
          openModalViewInvoice={openModalViewInvoice}
          setTickets={setTickets}
          setInfo={setInfo}
          openModalEditInvoice={openModalEditInvoice}
          handleApplyPaymentInvoice={handleApplyPaymentInvoice}
          setShowInvoiceInApply={setShowInvoiceInApply}
          accumulateInvoiceApply={accumulateInvoiceApply}
          setAccumulateInvoiceApply={setAccumulateInvoiceApply}
          infoPayments={filteredInfoPayments}
          tableLoading={tableLoading}
        ></Row>
      </>
    );
  } else {
    return (
      <div className='flex flex-col flex-1 items-center justify-center p-24 '>
        <Paper className='rounded-full p-48 md:p-64 shadow-xl'>
          <img
            src='assets/images/logos/inspection.png'
            className='w-128 m-32'
            color='secondary'
          ></img>
        </Paper>
        <Typography variant='h6' className='mt-24 mb-12 text-32 font-700' color='black'>
          {t('CUSTOMERS_INFO')}
        </Typography>
        <Typography
          className='hidden md:flex px-16 pb-24 text-16 text-center'
          color='textSecondary'
        >
          {t('CHOOSE_CUSTOMER_INVOCE_DETAILS')}
        </Typography>
        {
          !customerId ? 

          <Button
           className='hidden md:flex'
           variant='contained'
           onClick={(e) => {
              e.stopPropagation();
              setCreate(true);
              openModalCustomer.current(true);
           }}
          >
            {t('CREATE_NEW_CUSTOMER')}
          </Button>
          :
          null

        }
        

        <Button
          onClick={() => handleDrawerToggle()}
          variant='outlined'
          color='third'
          className='flex md:hidden'
        >
          Select Customer to View Invoices
        </Button>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.loadz_auth?.AuthReducer?.user,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getBolPendingCount: (payload, onError) => dispatch(JobAction.getBolPendingCount(payload, onError)),
});

export default withReducer(
  'loadz_jobs',
  JobReducer
)(connect(mapStateToProps, mapDispatchToProps)(ClientsData));
//TODO improved messages.
